import React, { useContext, useEffect, useState } from "react";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import ProcessOne from "./steps/ProcessOne";
import { Case, If } from "~/common/components/If";
import ProcessTwo from "./steps/ProcessTwo";
import ProcessThree from "./steps/ProcessThree";
import ProcessFour from "./steps/ProcessFour";
import ProcessFive from "./steps/ProcessFive";
import { AppManContext } from "../../RoundManContext";
import { useTranslation } from "react-i18next";

const ModalEvalSetting = ({ evaluateSetupModal, setEvaluateSetupModal }) => {
	const { t } = useTranslation();
	const { processStep, setProcessStep, setResultProcessOne } = useContext(AppManContext);
	const [prcOneSelect, setPrcOneSelect] = useState();

	const { modiData } = useContext(AppManContext);

	useEffect(() => {
		if (modiData?.round?.Review) setResultProcessOne(modiData.round.Review);
		setPrcOneSelect(0);
	}, [evaluateSetupModal]);

	return (
		<>
			<ModalTemplate
				modalState={evaluateSetupModal}
				setModalToggle={setEvaluateSetupModal}
				title={
					<>
						{t(
							"pages.round.RoundManage.modal.evaluationSetting.ModalEvalSetting.title"
						)}
						<h3>{modiData?.round?.title}</h3>
					</>
				}
				width={1100}
				className="evaluate-setup-modal"
			>
				<If
					condition={processStep}
					{...{ processStep, setProcessStep, setEvaluateSetupModal }}
				>
					<Case condition={0}>
						{/*---등록 1*/}
						<ProcessOne {...{ prcOneSelect, setPrcOneSelect, modiData }} />
					</Case>
					<Case condition={1}>
						{/*---등록 2*/}
						<ProcessTwo />
					</Case>
					<Case condition={2}>
						{/*---등록 3*/}
						<ProcessThree />
					</Case>
					{/*<Case condition={3}>*/}
					{/*	/!*---등록 4*!/*/}
					{/*	<ProcessFour />*/}
					{/*</Case>*/}
					<Case condition={4}>
						{/*---최종 5*/}
						<ProcessFive {...{ setEvaluateSetupModal }} />
					</Case>
				</If>
			</ModalTemplate>
		</>
	);
};

export default ModalEvalSetting;
